import styled from 'styled-components';
import { COLORS } from '../../../../../constants/radar';

export const EmployeesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
`;

export const EmployeeCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  height: fit-content;
  width: 100%;
  border: 1px solid #e0e0e0;
  box-shadow: none;
`;

export const EmployeeCardContent = styled.div`
  padding: 16px;
`;

export const EmployeeName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  margin-bottom: 2px;
`;

export const EmployeeRole = styled.div`
  font-size: 13px;
  color: #64748B;
`;

export const EmployeeDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  color: #475569;
`;